/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


const scrollHeader = () => {
  let lastScrollTop = 0;
  const ticker = document.querySelector('#shopify-section-announcement-bar');
  const header = document.querySelector('#shopify-section-header');

  if (window.scrollY > window.innerHeight) {
    if(ticker) {
      ticker.classList.add('announcement-scrolled');
    }
    header.classList.remove('header-down');
    header.classList.add('header-up')
  }
  document.addEventListener('scroll', (e) => {

    if(ticker) {
      let scrollPosition = window.scrollY;
      if (scrollPosition > 1) {
        ticker.classList.add('announcement-scrolled')
      } else {
        ticker.classList.remove('announcement-scrolled')
      }
    }


    let st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    if (st > lastScrollTop) {
      // downscroll code
      header.classList.add('header-down')
      header.classList.remove('header-up')

    } else {
      // upscroll code
      header.classList.remove('header-down');
      header.classList.add('header-up')
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  }, false)

};
const stickyATC = () => {
  const swatches = document.querySelector('.product-form');
  const productSelect = document.querySelector('#mobile_select');
  const productSelectSingle = document.querySelector('#mobile_select_single');

  document.addEventListener('scroll', (e) => {
    let scrollPosition = window.scrollY;
    let screenHeight = window.innerHeight;
    if (scrollPosition > screenHeight) {
      swatches.classList.add('sticky-swatches')
    } else {
      swatches.classList.remove('sticky-swatches')
    }
    if (scrollPosition > screenHeight + 100) {
      swatches.classList.add('sticky-swatches-display')
      document.querySelector('body').classList.add('sticky-atc--active')
    } else {
      swatches.classList.remove('sticky-swatches-display')
      document.querySelector('body').classList.remove('sticky-atc--active')
    }

  })
  if (productSelect !== null) {
    productSelect.addEventListener('change', function (e) {
      const selectedOption = e.target[e.target.selectedIndex];
      console.log('selectedOption',selectedOption)
      const variatId = e.target.value
      const sellingPlan = selectedOption.dataset.plan;
      const secondaryForm = document.querySelector('.secondary-product-form');
      const secondaryFormButton = document.querySelector('.secondary-product-form button');
      const mainForm = document.querySelector('.product-form__payment-container');
      const mainFormButton = document.querySelector('.shopify-product-form button'); 

      if (sellingPlan !== undefined) {
        document.querySelector('.secondary-product-form input#input-var-id').value = variatId;
        document.querySelector('.secondary-product-form input#selling-plan').value = sellingPlan;
        secondaryForm.classList.remove('js-hidden');
        secondaryFormButton.classList.remove('js-hidden');
        mainFormButton.classList.add('js-hidden');
        mainForm.classList.add('js-hidden');

      } else {
        document.querySelector('.shopify-product-form input#main-input-var-id').value = variatId;
        secondaryForm.classList.add('js-hidden');
        secondaryFormButton.classList.add('js-hidden');
        mainFormButton.classList.remove('js-hidden');
        mainForm.classList.remove('js-hidden');


      }
    });
  }
  if (productSelectSingle !== null) {
    productSelectSingle.addEventListener('change', function (e) {
      const selectedValue = e.target.value;
      const secondaryForm = document.querySelector('.secondary-product-form');
      const secondaryFormButton = document.querySelector('.secondary-product-form button');
      const mainForm = document.querySelector('.product-form__payment-container');
      const mainFormButton = document.querySelector('.shopify-product-form button');

      if (selectedValue == 'auto') {
        secondaryForm.classList.remove('js-hidden');
        secondaryFormButton.classList.remove('js-hidden');
        mainFormButton.classList.add('js-hidden');
        mainForm.classList.add('js-hidden');
      } else {
        secondaryForm.classList.add('js-hidden');
        secondaryFormButton.classList.add('js-hidden');
        mainFormButton.classList.remove('js-hidden');
        mainForm.classList.remove('js-hidden');
      }
    })
  }
}

function docReady(fn) {
  // see if DOM is already available
  if (document.readyState === "complete" || document.readyState === "interactive") {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

docReady(function () {


  const headerButton = document.querySelector('.nav-quickbuy-desktop');
  const body = document.querySelector('body');
  const loc = window.location.pathname;

  /* General Code */
  scrollHeader();


  /* PDP code */
  if (body.classList.contains('template--combined-pdp')) {
    stickyATC();
  }

  /* PLP Code */
  if (loc.includes('/collections')) {
    const oneGridBtn = document.querySelector('.display-one-column');
    const twoGridBtn = document.querySelector('.display-two-column');

    oneGridBtn.addEventListener('click', function () {
      const productList = document.querySelector('.product-list__inner');
      const disBtn = document.querySelector('.disabled-btn')
      productList.classList.add('one-column-grid');
      if (disBtn !== null) {
        disBtn.classList.remove('disabled-btn')
      }
      this.classList.add('disabled-btn');

    });
    twoGridBtn.addEventListener('click', function () {
      const productList = document.querySelector('.product-list__inner');
      const disBtn = document.querySelector('.disabled-btn');
      productList.classList.remove('one-column-grid');
      if (disBtn !== null) {
        disBtn.classList.remove('disabled-btn')
      }


      this.classList.add('disabled-btn');
    });
  }
  if (loc.includes('/bundle-collection')) {
    const cards = Array.from(document.querySelectorAll('.product-item'));

    cards.map(function (card) {
      const card_title = card.querySelector('.product-item-meta__title');
      const card_scent = card.querySelector('.product-item-info-header span');
      const card_reviews = card.querySelector('.product-item-meta__reviews-badge');
      const card_form_btn = card.querySelector('.bundle_add .loader-button__text');

      const card_img = card.querySelector('.product-item__image-wrapper');

      const add_product = function (e) {
        e.preventDefault()
        card_form_btn.click()

      }
      card_img.addEventListener('click', add_product)
      card_title.addEventListener('click', add_product);
      card_scent.addEventListener('click', add_product);
      card_reviews.addEventListener('click', add_product);

    })
  }

});
document.addEventListener("DOMContentLoaded", () => {
  const frequencyModalTriggers = document.querySelectorAll(
    "[data-frequency-modal-trigger]"
  );
  frequencyModalTriggers.forEach((modalTrigger) => {
    console.log(modalTrigger)
    const wrapper = modalTrigger.closest("[data-frequency-container]");
    if (wrapper) {
      const modal = wrapper.querySelector("[data-frequency-modal]");
      if (modal) {
        const modalCloser = modal.querySelector('[rel="modal:close"]');
        const modalOptions = modal.querySelectorAll("[data-modal-option]");
        modalTrigger.addEventListener("click", (e) => {
          e.stopPropagation();
          e.preventDefault();
          modal.style.zIndex = 10;
          modal.style.opacity = 1;
          document.querySelector("body").style.overflow = "hidden";
        });
        if (modalCloser) {
          modalCloser.addEventListener("click", (e) => {
            e.preventDefault();
            modal.addEventListener(
              "transitionend",
              () => {
                modal.style.zIndex = "-10";
                document.querySelector("body").style.overflow = null;
              },
              { once: true }
            );
            modal.style.opacity = 0;
          });
          document.addEventListener("variant:added", () => {
            modalCloser.click();
            if (modal.querySelector("button")) {
              modal.querySelector("button").setAttribute("aria-busy", "false");
            }
          });
        }
        modalOptions.forEach((option) => {
          option.addEventListener("change", (e) => {
            const matchingValue = document.querySelector(
              `[value=${e.target.value}]`
            );
            if (matchingValue) {
              matchingValue.closest("select").value = e.target.value;
              matchingValue.closest("select").dispatchEvent(
                new Event("change", { bubbles: true })
              );
            }
          });
        });
      }
    }
  });
});

function setCampaignFromURL() {
  let currentCampaign = false
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  currentCampaign = urlParams.get('utm_campaign');
  
  if(currentCampaign) {
    let formData = {
      attributes: {
        '_custom_campaign': `${currentCampaign}`
      }
    };
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      document.body.classList.add(`td-campaign-${currentCampaign}`);
      document.body.dataset.campaign = currentCampaign;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}
window.addEventListener('load', setCampaignFromURL);

if (!customElements.get("class-toggler")) {
  class ClassToggler extends HTMLElement {
    constructor() {
      super();
      this.triggers = this.querySelectorAll("[data-element-to-toggle]");
      this.classToToggle = this.getAttribute("data-class-to-toggle");
      this.activeTriggerClass = "active";
    }

    connectedCallback() {
      this.triggers.forEach((trigger) => {
        trigger.addEventListener("click", this.toggleChildClass.bind(this));
      });
    }

    toggleChildClass(event) {
      const triggerElement = event.currentTarget;
      const elementToToggle = document.querySelectorAll(
        triggerElement.getAttribute("data-element-to-toggle")
      );
      if (!elementToToggle || !this.classToToggle) {
        console.error(
         `Element to toggle (${triggerElement.getAttribute("data-element-to-toggle")}) or class to toggle (${this.classToToggle}) not found or invalid.`
        );
        return;
      }
      this.triggers.forEach((trigger) => {
        if (trigger.id == triggerElement.id) {
          triggerElement.classList.add("active");
          elementToToggle.forEach((el) => el.classList.add(this.classToToggle));
        } else {
          trigger.classList.remove("active");
          const activeElement = document.querySelectorAll(
            trigger.getAttribute("data-element-to-toggle") + '.' + this.classToToggle
          );
          if (activeElement.length > 0) {
            activeElement.forEach((el) => el.classList.remove(this.classToToggle));
          }
        }
      });
    }
  }
  customElements.define("class-toggler", ClassToggler);
}


(function() {
  if (window.location.pathname === '/cart') {
    window.location.href = '/?cart=open';
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('cart') === 'open') {
      document.documentElement.dispatchEvent(new CustomEvent('cart:open', {
        bubbles: true,
        detail: { openMiniCart: true }
      }));
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete('cart');
      history.replaceState({}, '', newUrl);
    }
  });
})();

(function() {
  window.addEventListener('message', (event) => {
    if (event.data && event.data.eventType === 'PIXEL_MESSAGE_BRIDGE') {      
      const eventName = event.data.eventName;
      if (eventName === 'native-cart:product-added') {
        if (document.querySelector('#replo-fullpage-element') !== null) {
          document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", {
                  bubbles: true,
                  detail: { 
                    openMiniCart: true,
                  }
              })
          );
        }
      }
    }
  });
})();